import { useCallback } from "react";
import { useApolloClient, gql } from "@apollo/client";
import { DeleteSchoolVariables } from "../__generated__/gql-types/DeleteSchool";

const useDeleteSchool = () => {
  const client = useApolloClient();
  return useCallback(
    async (input: DeleteSchoolVariables) => {
      return await client.mutate({
        mutation: DELETE_SCHOOL,
        fetchPolicy: "no-cache",
        variables: input,
      });
    },
    [client]
  );
};

export default useDeleteSchool;

const DELETE_SCHOOL = gql`
  mutation DeleteSchool($deleteSchoolId: ID!) {
    deleteSchool(id: $deleteSchoolId) {
      id
      name
      deleted_at
    }
  }
`;
